import _ from 'lodash'

export const downloadFileWithAjax = (url, customName, callback) => {
  return new Promise((resolve) => {
    var xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'arraybuffer'
    xhr.setRequestHeader('fturl', window.location.href)
    xhr.onload = function () {
      //- $(".processing_merge_content").html(labelDone)
      try {
        if (xhr.status != 200) {
          return resolve({ status: false })
        }
        var type = xhr.getResponseHeader('Content-Type')
        var disposition = xhr.getResponseHeader('Content-Disposition')
        var fileName = 'File'
        if (customName) {
          fileName = customName
        } else if (disposition && String(disposition).indexOf('filename=') > -1) {
          fileName = String(disposition).split('filename=')[1]
        }
        var blob =
          typeof File === 'function'
            ? new File([this.response], fileName, { type: type })
            : new Blob([this.response], { type: type })

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, fileName)
        } else {
          var URL = window.URL || window.webkitURL
          var downloadUrl = URL.createObjectURL(blob)

          if (fileName) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement('a')
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl
            } else {
              a.href = downloadUrl
              a.download = fileName
              document.body.appendChild(a)
              a.click()
            }
          } else {
            window.location = downloadUrl
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl)
            if (callback && typeof callback === 'function') {
              callback()
            }
          }, 100) // cleanup
        }
      } catch (err) {
        console.error(err)
      }

      resolve({ status: true })
    }

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhr.send('')
  })
}

export const postDownloadFileWithAjax = (url, customName, data = {}, callback) => {
  return new Promise((resolve) => {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.responseType = 'arraybuffer'
    xhr.setRequestHeader('fturl', window.location.href)
    xhr.onload = function () {
      //- $(".processing_merge_content").html(labelDone)
      try {
        if (xhr.status != 200) {
          return resolve(false)
        }
        var type = xhr.getResponseHeader('Content-Type')
        var disposition = xhr.getResponseHeader('Content-Disposition')
        if (String(type).includes('application/json')) {
          return resolve(false)
        }
        var fileName = 'File'
        if (customName) {
          fileName = customName
        } else if (disposition && String(disposition).indexOf('filename=') > -1) {
          fileName = String(disposition).split('filename=')[1]
        }
        if (String(fileName).indexOf('.') === -1) {
          if (type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            fileName += '.docx'
          } else {
            fileName += '.pdf'
          }
        }

        var blob =
          typeof File === 'function'
            ? new File([this.response], fileName, { type: type })
            : new Blob([this.response], { type: type })

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, fileName)
        } else {
          var URL = window.URL || window.webkitURL
          var downloadUrl = URL.createObjectURL(blob)

          if (fileName) {
            // use HTML5 a[download] attribute to specify filename
            var a = document.createElement('a')
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl
            } else {
              a.href = downloadUrl
              a.download = fileName
              document.body.appendChild(a)
              a.click()
            }
          } else {
            window.location = downloadUrl
          }

          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl)

            if (callback && typeof callback === 'function') {
              callback()
            }
          }, 100) // cleanup
        }
      } catch (err) {
        console.error(err)
      }

      resolve(true)
    }

    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')

    xhr.send(`data=${encodeURIComponent(JSON.stringify(data))}`)
  })
}
